// Module
var code = "<div class=\"ui basic segment host host--track overview--admin\" ng-controller=\"secureController as secureCtrl\"> <journey-host></journey-host> </div> ";
// Exports
module.exports = code;